import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthenticationService } from '../auth/authentication.service';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class ResultadoService {
  constructor(
    private http: HttpClient,
    private auth: AuthenticationService) { }

  public obterResultadoPdf(extraInfo: any): Observable<any> {
    const options = {
      responseType: 'text' as 'text',
      headers: new HttpHeaders()
        .append('client_id', environment.auth.client_id)
        .append('access_token', this.auth.accessToken),
      params: new HttpParams()
        .set('listaItens', this.decryptText(extraInfo.listaItens))
        .set('bloqueioPorSenha',true.toString())
    };

    return this.http
      .get(`${environment.host}/cliente/v1/fichas/${this.decryptText(extraInfo.numFicha)}/resultado-pdf`, options);
  }

  public resultadoVisualizado(extraInfo: any): Observable<any> {
    const options = {
      responseType: 'text' as 'text',
      headers: new HttpHeaders()
        .append('client_id', environment.auth.client_id)
        .append('access_token', this.auth.accessToken)
    };

    const body = {
      numeroFicha:  this.decryptText(extraInfo.numFicha),
      listaItens:   this.decryptText(extraInfo.listaItens)
    };

    return this.http
      .put(`${environment.host}/resultado-email/v1/visualizado`,body, options);
  }

  decryptText(text: string) {
    return CryptoJS.AES.decrypt(text, CryptoJS.enc.Base64.parse(btoa(environment.aesSecret)),{
      iv: CryptoJS.enc.Base64.parse(btoa(environment.aesIv)),
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);
  }
}
